import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import changeReducerFactory from './factories/changeReducerFactory';
import detailReducerFactory from './factories/detailReducerFactory';
import entityReducerFactory from './factories/entityReducerFactory';
import applyReducer, { reduceReducers } from './applyReducer';
import formConstants from '../constants/formConstants';
import jobConstants from '../constants/jobConstants';
const changeReducer = changeReducerFactory('job');
const detailReducer = detailReducerFactory('job');
const entityReducer = entityReducerFactory('job');
const defaultIndexQuery = _objectSpread(_objectSpread({}, entityReducer.initState.indexQuery), {}, {
  filters: {
    closed: '0'
  },
  sortDirection: 'DESC'
});
const initState = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, changeReducer.initState), detailReducer.initState), entityReducer.initState), {}, {
  activeRemotePath: null,
  hasPrevious: false,
  hasNext: false,
  indexQuery: defaultIndexQuery,
  initialIndexQuery: defaultIndexQuery,
  permissions: {
    view: {
      include: ['job_edit']
    },
    edit: {
      include: ['job_edit']
    }
  }
});

/**
 *  Clear the job info whenever a form save or job index occurs, which will cause the job to reload
 *  and pick up any changes made by behaviors. Hard to optimize since it's not easy to determine
 *  what forms relate to the job, especially if it's a sub-form, so clear on everything.
 */
const clearActiveJob = state => {
  // don't reload the job if it's still in the process of saving
  if (!state.pendingChanges) {
    return _objectSpread(_objectSpread({}, state), {}, {
      active: {}
    });
  }
  return state;
};

/**
 *  Due to the asynchronous nature of transitions, it's necessary to keep track
 *  of the job ID for which the save was canceled in the transition alert in order
 *  to avoid trying to reload while the editor component is unmounting
 */
const clearCanceledID = state => _objectSpread(_objectSpread({}, state), {}, {
  lastCanceledID: null
});
const setCanceledID = state => _objectSpread(_objectSpread({}, state), {}, {
  lastCanceledID: state.active.id
});
const reducers = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, changeReducer.reducers), detailReducer.reducers), entityReducer.reducers), {}, {
  [formConstants.SAVE_SUCCESS]: clearActiveJob,
  // the built-in reloading of detail data from the index view isn't working well with the form
  // within a job approach and leads to complex update problems: https://www.pivotaltracker.com/story/show/170407104.
  // Instead of complicated logic in FormEditor, just clear the active job when the index view
  // reloads. There are still cases using browser buttons and direct URLs where stale detail data
  // can be accessed. To fix, the job-specific parts of a form should really be removed.
  [jobConstants.INDEX_SUCCESS]: reduceReducers(entityReducer.reducers[jobConstants.INDEX_SUCCESS], clearActiveJob),
  // clear the last canceled job when the form is loaded. jobConstants.SHOW will not work because
  // this event is dispatched by the component
  [formConstants.SHOW]: clearCanceledID,
  // set the canceledID to the current job so that the component doesn't try to reload during the
  // transition
  [jobConstants.SHOW_CANCEL]: reduceReducers(setCanceledID, detailReducer.reducers[jobConstants.SHOW_CANCEL])
});
export default applyReducer(reducers, initState);